export const SET_EDIT_USER_DATA = 'SET_EDIT_USER_DATA';

export function setEditMatchData(user) {
  return {
    type: SET_EDIT_USER_DATA,
    user,
  };
}
